import type {
  ClientCityPropertyConfig,
  ClientUrlConfig,
} from "../types/globalTypes";

export const BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3000";

export const COUNTRY_OPTIONS = [
  { name: "Afghanistan", code: "+93", flag: "af" },
  { name: "Albania", code: "+355", flag: "al" },
  { name: "Algeria", code: "+213", flag: "dz" },
  { name: "Andorra", code: "+376", flag: "ad" },
  { name: "Angola", code: "+244", flag: "ao" },
  { name: "Anguilla", code: "+1264", flag: "ai" },
  { name: "Antigua and Barbuda", code: "+1268", flag: "ag" },
  { name: "Argentina", code: "+54", flag: "ar" },
  { name: "Armenia", code: "+374", flag: "am" },
  { name: "Aruba", code: "+297", flag: "aw" },
  { name: "Australia", code: "+61", flag: "au" },
  { name: "Austria", code: "+43", flag: "at" },
  { name: "Azerbaijan", code: "+994", flag: "az" },
  { name: "Bahamas", code: "+1242", flag: "bs" },
  { name: "Bahrain", code: "+973", flag: "bh" },
  { name: "Bangladesh", code: "+880", flag: "bd" },
  { name: "Barbados", code: "+1246", flag: "bb" },
  { name: "Belarus", code: "+375", flag: "by" },
  { name: "Belgium", code: "+32", flag: "be" },
  { name: "Belize", code: "+501", flag: "bz" },
  { name: "Benin", code: "+229", flag: "bj" },
  { name: "Bermuda", code: "+1441", flag: "bm" },
  { name: "Bhutan", code: "+975", flag: "bt" },
  { name: "Bolivia", code: "+591", flag: "bo" },
  { name: "Bosnia and Herzegovina", code: "+387", flag: "ba" },
  { name: "Botswana", code: "+267", flag: "bw" },
  { name: "Brazil", code: "+55", flag: "br" },
  { name: "British Virgin Islands", code: "+1284", flag: "vg" },
  { name: "Brunei", code: "+673", flag: "bn" },
  { name: "Bulgaria", code: "+359", flag: "bg" },
  { name: "Burkina Faso", code: "+226", flag: "bf" },
  { name: "Burundi", code: "+257", flag: "bi" },
  { name: "Cambodia", code: "+855", flag: "kh" },
  { name: "Cameroon", code: "+237", flag: "cm" },
  { name: "Canada", code: "+1", flag: "ca" },
  { name: "Cape Verde", code: "+238", flag: "cv" },
  { name: "Cayman Islands", code: "+1345", flag: "ky" },
  { name: "Central African Republic", code: "+236", flag: "cf" },
  { name: "Chad", code: "+235", flag: "td" },
  { name: "Chile", code: "+56", flag: "cl" },
  { name: "China", code: "+86", flag: "cn" },
  { name: "Colombia", code: "+57", flag: "co" },
  { name: "Comoros", code: "+269", flag: "km" },
  { name: "Congo", code: "+242", flag: "cg" },
  { name: "Cook Islands", code: "+682", flag: "ck" },
  { name: "Costa Rica", code: "+506", flag: "cr" },
  { name: "Côte d'Ivoire", code: "+225", flag: "ci" },
  { name: "Croatia", code: "+385", flag: "hr" },
  { name: "Cuba", code: "+53", flag: "cu" },
  { name: "Curaçao", code: "+599", flag: "cw" },
  { name: "Cyprus", code: "+357", flag: "cy" },
  { name: "Czech Republic", code: "+420", flag: "cz" },
  { name: "Denmark", code: "+45", flag: "dk" },
  { name: "Djibouti", code: "+253", flag: "dj" },
  { name: "Dominica", code: "+1767", flag: "dm" },
  { name: "Dominican Republic", code: "+1809", flag: "do" },
  { name: "Ecuador", code: "+593", flag: "ec" },
  { name: "Egypt", code: "+20", flag: "eg" },
  { name: "El Salvador", code: "+503", flag: "sv" },
  { name: "Equatorial Guinea", code: "+240", flag: "gq" },
  { name: "Eritrea", code: "+291", flag: "er" },
  { name: "Estonia", code: "+372", flag: "ee" },
  { name: "Eswatini", code: "+268", flag: "sz" },
  { name: "Ethiopia", code: "+251", flag: "et" },
  { name: "Falkland Islands", code: "+500", flag: "fk" },
  { name: "Faroe Islands", code: "+298", flag: "fo" },
  { name: "Fiji", code: "+679", flag: "fj" },
  { name: "Finland", code: "+358", flag: "fi" },
  { name: "France", code: "+33", flag: "fr" },
  { name: "French Guiana", code: "+594", flag: "gf" },
  { name: "French Polynesia", code: "+689", flag: "pf" },
  { name: "Gabon", code: "+241", flag: "ga" },
  { name: "Gambia", code: "+220", flag: "gm" },
  { name: "Georgia", code: "+995", flag: "ge" },
  { name: "Germany", code: "+49", flag: "de" },
  { name: "Ghana", code: "+233", flag: "gh" },
  { name: "Gibraltar", code: "+350", flag: "gi" },
  { name: "Greece", code: "+30", flag: "gr" },
  { name: "Greenland", code: "+299", flag: "gl" },
  { name: "Grenada", code: "+1473", flag: "gd" },
  { name: "Guadeloupe", code: "+590", flag: "gp" },
  { name: "Guam", code: "+1671", flag: "gu" },
  { name: "Guatemala", code: "+502", flag: "gt" },
  { name: "Guernsey", code: "+44", flag: "gg" },
  { name: "Guinea", code: "+224", flag: "gn" },
  { name: "Guinea-Bissau", code: "+245", flag: "gw" },
  { name: "Guyana", code: "+592", flag: "gy" },
  { name: "Haiti", code: "+509", flag: "ht" },
  { name: "Honduras", code: "+504", flag: "hn" },
  { name: "Hong Kong", code: "+852", flag: "hk" },
  { name: "Hungary", code: "+36", flag: "hu" },
  { name: "Iceland", code: "+354", flag: "is" },
  { name: "India", code: "+91", flag: "in" },
  { name: "Indonesia", code: "+62", flag: "id" },
  { name: "Iran", code: "+98", flag: "ir" },
  { name: "Iraq", code: "+964", flag: "iq" },
  { name: "Ireland", code: "+353", flag: "ie" },
  { name: "Isle of Man", code: "+44", flag: "im" },
  { name: "Israel", code: "+972", flag: "il" },
  { name: "Italy", code: "+39", flag: "it" },
  { name: "Jamaica", code: "+1876", flag: "jm" },
  { name: "Japan", code: "+81", flag: "jp" },
  { name: "Jersey", code: "+44", flag: "je" },
  { name: "Jordan", code: "+962", flag: "jo" },
  { name: "Kazakhstan", code: "+7", flag: "kz" },
  { name: "Kenya", code: "+254", flag: "ke" },
  { name: "Kiribati", code: "+686", flag: "ki" },
  { name: "North Korea", code: "+850", flag: "kp" },
  { name: "South Korea", code: "+82", flag: "kr" },
  { name: "Kosovo", code: "+383", flag: "xk" },
  { name: "Kuwait", code: "+965", flag: "kw" },
  { name: "Kyrgyzstan", code: "+996", flag: "kg" },
  { name: "Laos", code: "+856", flag: "la" },
  { name: "Latvia", code: "+371", flag: "lv" },
  { name: "Lebanon", code: "+961", flag: "lb" },
  { name: "Lesotho", code: "+266", flag: "ls" },
  { name: "Liberia", code: "+231", flag: "lr" },
  { name: "Libya", code: "+218", flag: "ly" },
  { name: "Liechtenstein", code: "+423", flag: "li" },
  { name: "Lithuania", code: "+370", flag: "lt" },
  { name: "Luxembourg", code: "+352", flag: "lu" },
  { name: "Macau", code: "+853", flag: "mo" },
  { name: "Madagascar", code: "+261", flag: "mg" },
  { name: "Malawi", code: "+265", flag: "mw" },
  { name: "Malaysia", code: "+60", flag: "my" },
  { name: "Maldives", code: "+960", flag: "mv" },
  { name: "Mali", code: "+223", flag: "ml" },
  { name: "Malta", code: "+356", flag: "mt" },
  { name: "Marshall Islands", code: "+692", flag: "mh" },
  { name: "Martinique", code: "+596", flag: "mq" },
  { name: "Mauritania", code: "+222", flag: "mr" },
  { name: "Mauritius", code: "+230", flag: "mu" },
  { name: "Mayotte", code: "+262", flag: "yt" },
  { name: "Mexico", code: "+52", flag: "mx" },
  { name: "Micronesia", code: "+691", flag: "fm" },
  { name: "Moldova", code: "+373", flag: "md" },
  { name: "Monaco", code: "+377", flag: "mc" },
  { name: "Mongolia", code: "+976", flag: "mn" },
  { name: "Montenegro", code: "+382", flag: "me" },
  { name: "Montserrat", code: "+1664", flag: "ms" },
  { name: "Morocco", code: "+212", flag: "ma" },
  { name: "Mozambique", code: "+258", flag: "mz" },
  { name: "Myanmar", code: "+95", flag: "mm" },
  { name: "Namibia", code: "+264", flag: "na" },
  { name: "Nauru", code: "+674", flag: "nr" },
  { name: "Nepal", code: "+977", flag: "np" },
  { name: "Netherlands", code: "+31", flag: "nl" },
  { name: "New Caledonia", code: "+687", flag: "nc" },
  { name: "New Zealand", code: "+64", flag: "nz" },
  { name: "Nicaragua", code: "+505", flag: "ni" },
  { name: "Niger", code: "+227", flag: "ne" },
  { name: "Nigeria", code: "+234", flag: "ng" },
  { name: "Niue", code: "+683", flag: "nu" },
  { name: "Northern Mariana Islands", code: "+1670", flag: "mp" },
  { name: "Norway", code: "+47", flag: "no" },
  { name: "Oman", code: "+968", flag: "om" },
  { name: "Pakistan", code: "+92", flag: "pk" },
  { name: "Palau", code: "+680", flag: "pw" },
  { name: "Palestine", code: "+970", flag: "ps" },
  { name: "Panama", code: "+507", flag: "pa" },
  { name: "Papua New Guinea", code: "+675", flag: "pg" },
  { name: "Paraguay", code: "+595", flag: "py" },
  { name: "Peru", code: "+51", flag: "pe" },
  { name: "Philippines", code: "+63", flag: "ph" },
  { name: "Pitcairn Islands", code: "+64", flag: "pn" },
  { name: "Poland", code: "+48", flag: "pl" },
  { name: "Portugal", code: "+351", flag: "pt" },
  { name: "Qatar", code: "+974", flag: "qa" },
  { name: "Réunion", code: "+262", flag: "re" },
  { name: "Romania", code: "+40", flag: "ro" },
  { name: "Russia", code: "+7", flag: "ru" },
  { name: "Rwanda", code: "+250", flag: "rw" },
  { name: "Saint Barthélemy", code: "+590", flag: "bl" },
  { name: "Saint Helena", code: "+290", flag: "sh" },
  { name: "Saint Kitts and Nevis", code: "+1869", flag: "kn" },
  { name: "Saint Lucia", code: "+1758", flag: "lc" },
  { name: "Saint Martin", code: "+590", flag: "mf" },
  { name: "Saint Pierre and Miquelon", code: "+508", flag: "pm" },
  { name: "Saint Vincent and the Grenadines", code: "+1784", flag: "vc" },
  { name: "Samoa", code: "+685", flag: "ws" },
  { name: "San Marino", code: "+378", flag: "sm" },
  { name: "Saudi Arabia", code: "+966", flag: "sa" },
  { name: "Senegal", code: "+221", flag: "sn" },
  { name: "Serbia", code: "+381", flag: "rs" },
  { name: "Seychelles", code: "+248", flag: "sc" },
  { name: "Sierra Leone", code: "+232", flag: "sl" },
  { name: "Singapore", code: "+65", flag: "sg" },
  { name: "Sint Maarten", code: "+1721", flag: "sx" },
  { name: "Slovakia", code: "+421", flag: "sk" },
  { name: "Slovenia", code: "+386", flag: "si" },
  { name: "Solomon Islands", code: "+677", flag: "sb" },
  { name: "Somalia", code: "+252", flag: "so" },
  { name: "South Africa", code: "+27", flag: "za" },
  {
    name: "South Georgia and South Sandwich Islands",
    code: "+500",
    flag: "gs",
  },
  { name: "South Sudan", code: "+211", flag: "ss" },
  { name: "Spain", code: "+34", flag: "es" },
  { name: "Sri Lanka", code: "+94", flag: "lk" },
  { name: "Sudan", code: "+249", flag: "sd" },
  { name: "Suriname", code: "+597", flag: "sr" },
  { name: "Sweden", code: "+46", flag: "se" },
  { name: "Switzerland", code: "+41", flag: "ch" },
  { name: "Syria", code: "+963", flag: "sy" },
  { name: "Taiwan", code: "+886", flag: "tw" },
  { name: "Tajikistan", code: "+992", flag: "tj" },
  { name: "Tanzania", code: "+255", flag: "tz" },
  { name: "Thailand", code: "+66", flag: "th" },
  { name: "Timor-Leste", code: "+670", flag: "tl" },
  { name: "Togo", code: "+228", flag: "tg" },
  { name: "Tokelau", code: "+690", flag: "tk" },
  { name: "Tonga", code: "+676", flag: "to" },
  { name: "Trinidad and Tobago", code: "+1868", flag: "tt" },
  { name: "Tunisia", code: "+216", flag: "tn" },
  { name: "Turkey", code: "+90", flag: "tr" },
  { name: "Turkmenistan", code: "+993", flag: "tm" },
  { name: "Turks and Caicos Islands", code: "+1649", flag: "tc" },
  { name: "Tuvalu", code: "+688", flag: "tv" },
  { name: "Uganda", code: "+256", flag: "ug" },
  { name: "Ukraine", code: "+380", flag: "ua" },
  { name: "United Arab Emirates", code: "+971", flag: "ae" },
  { name: "United Kingdom", code: "+44", flag: "gb" },
  { name: "United States", code: "+1", flag: "us" },
  { name: "U.S. Virgin Islands", code: "+1340", flag: "vi" },
  { name: "Uruguay", code: "+598", flag: "uy" },
  { name: "Uzbekistan", code: "+998", flag: "uz" },
  { name: "Vanuatu", code: "+678", flag: "vu" },
  { name: "Vatican City", code: "+379", flag: "va" },
  { name: "Venezuela", code: "+58", flag: "ve" },
  { name: "Vietnam", code: "+84", flag: "vn" },
  { name: "Wallis and Futuna", code: "+681", flag: "wf" },
  { name: "Yemen", code: "+967", flag: "ye" },
  { name: "Zambia", code: "+260", flag: "zm" },
  { name: "Zimbabwe", code: "+263", flag: "zw" },
];

export const urlChangeListenerClients = [
  "cloudstudent",
  "scape",
  "moda",
  "hfs",
  "universalstudentliving",
  "essentialstudentliving",
  "urbanstudentlife",
  "evostudent",
  "prestigestudentliving",
  "collegiateeu",
  "milestone",
  "mansionstudent",
  "aparto",
];

export const clientLanguageIndexConfig: Record<string, number> = {
  milestone: 0,
};

export const clientUrlPatternsConfig: ClientUrlConfig = {
  "www.vitastudent.com": {
    clientCode: "vita",
    cityIndex: 2,
    propertyIndex: 3,
    autoSelectSingleProperty: true,
  },
  "www.downingstudents.com": {
    clientCode: "downingstudents",
    cityIndex: 1,
    propertyIndex: 2,
    autoSelectSingleProperty: true,
  },
  "www.therailyard.co.uk": {
    clientCode: "railyard",
    cityIndex: 0,
    propertyIndex: 1,
    autoSelectSingleProperty: true,
  },
  "www.fusionstudents.co.uk": {
    clientCode: "fusiongroup",
    cityIndex: 1,
  },
  "www.scape.com": {
    clientCode: "scape",
    cityIndex: 0,
  },
  "studentcastle.co.uk": {
    clientCode: "studentcastle",
    cityIndex: 1,
  },
  "www.studentcastle.co.uk": {
    clientCode: "studentcastle",
    cityIndex: 1,
  },
  "cloudstudenthomes.co.uk": {
    clientCode: "cloudstudent",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "londonist.co.uk": {
    clientCode: "londonist",
  },
  "modaliving.com": {
    clientCode: "moda",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.milestone.net": {
    clientCode: "milestone",
  },
  "www.universalstudentliving.com": {
    clientCode: "universalstudentliving",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "essentialstudentliving.com": {
    clientCode: "essentialstudentliving",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "evostudent.com": {
    clientCode: "evostudent",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.urbanstudentlife.com": {
    clientCode: "urbanstudentlife",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "prestigestudentliving.com": {
    clientCode: "prestigestudentliving",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "wearehomesforstudents.com": {
    clientCode: "hfs",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.collegiate.it": {
    clientCode: "collegiateeu",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.collegiate-ac.es": {
    clientCode: "collegiateeu",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.collegiate-ac.es/en": {
    clientCode: "collegiateeu",
    cityIndex: 2,
    propertyIndex: 3,
  },
  "www.collegiate.it/en": {
    clientCode: "collegiateeu",
    cityIndex: 2,
    propertyIndex: 3,
  },
  "studentfm.co.uk": {
    clientCode: "studentfm",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "capitolstudents.com": {
    clientCode: "capitolstudents",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.capitolstudents.com": {
    clientCode: "capitolstudents",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "hello-homie.com": {
    clientCode: "hellohomie",
    cityIndex: 1,
    propertyIndex: 1,
  },
  "property-sense.co.uk": {
    clientCode: "propertysense",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "ypp.co.uk": {
    clientCode: "ypp",
    cityIndex: 0,
    propertyIndex: 1,
  },
  "neostudent.co.uk": {
    clientCode: "neostudents",
    cityIndex: 1,
    propertyIndex: 1,
  },
  "triberaliving.com": {
    clientCode: "milestone",
    cityIndex: 0,
    propertyIndex: 1,
  },
  "almerostudent.com": {
    clientCode: "almerostudent",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "nowstudents.co.uk": {
    clientCode: "nowstudents",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.unionatmidtown.com": {
    clientCode: "unionatmidtown",
    cityIndex: 1,
  },
  "www.unionatdearborn.com": {
    clientCode: "unionatdearborn",
    cityIndex: 1,
  },
  "www.truestudent.com": {
    clientCode: "truestudent",
    cityIndex: 0,
  },
  "www.yourtribe.com": {
    clientCode: "yourtribe",
    cityIndex: 0,
    propertyIndex: 1,
  },
  "www.thisisluna.co.uk": {
    clientCode: "lunastudents",
    cityIndex: 1,
    propertyIndex: 1,
  },
  "www.mansionstudent.co.uk": {
    clientCode: "mansionstudent",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.iconinc.co.uk": {
    clientCode: "iconinc",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "apartostudent.com": {
    clientCode: "aparto",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.apartostudent.com": {
    clientCode: "aparto",
    cityIndex: 1,
    propertyIndex: 2,
  },
  "www.pfpstudents.co.uk": {
    clientCode: "pfpstudents",
    cityIndex: 2,
    propertyIndex: 3,
  },
  "www.collegiate-ac.com": {
    clientCode: "collegiateeu",
    cityIndex: 1,
    propertyIndex: 2,
  },
};

export const clientCityPropertyConfig: ClientCityPropertyConfig = {
  vita: {
    Belfast: ["Bruce Street"],
    Birmingham: ["Pebble Mill", "Gough Street"],
    Bristol: ["Zed Alley"],
    Cardiff: ["Park Place"],
    Coventry: ["Copper Towers", "Warwick Cannon Park"],
    Edinburgh: ["New Waverley", "Iona Street", "Fountainbridge"],
    Exeter: ["Portland House"],
    Glasgow: ["West End"],
    Leeds: ["Portland Crescent", "St Albans"],
    Liverpool: ["Crosshall St."],
    London: ["Lewisham Exchange"],
    Manchester: ["First Street", "Circle Square"],
    Newcastle: ["Leazes Park", "Westgate", "Strawberry Place"],
    Nottingham: ["Station Street"],
    Sheffield: ["Telephone House"],
    Southampton: ["Richmond House"],
    York: ["Lawrence Street"],
    Barcelona: ["Poblenou", "Pedralbes"],
    Madrid: ["Oria"],
  },
  downingstudents: {
    Cambridge: ["The Railyard"],
    Coventry: ["City Village"],
    Exeter: ["The Kingfisher"],
    Edinburgh: ["New Park"],
    Glasgow: ["West Village", "West View"],
    Leeds: ["CitySide"],
    Liverpool: ["The Arch", "The Electra"],
    London: ["The Lyra", "Atlas"],
    Manchester: ["Square Gardens"],
    Newcastle: ["Verde", "The View"],
  },
  railyard: {
    Cambridge: ["Railyard"],
  },
  fusiongroup: {
    "Brent Cross Town": ["Fusion Brent Cross Town"],
    Liverpool: ["Fusion Liverpool"],
    Nottingham: ["Fusion Nottingham"],
    York: ["Fusion York"],
    Leeds: ["Fusion Leeds"],
    Manchester: ["Fusion Manchester"],
  },
  scape: {
    London: [
      "Bloomsbury",
      "Canada Water",
      "Hammersmith",
      "Kings Cross",
      "Mile End",
      "Shoreditch",
      "Wembley",
      "Scape London",
    ],
    Guildford: ["Scape Guildford"],
    Leeds: ["Scape Leeds"],
  },
  studentcastle: {
    Bath: ["Student Castle Bath"],
    Brighton: ["Student Castle Brighton"],
    Cambridge: ["Student Castle Cambridge"],
    Durham: ["Student Castle Durham"],
    Edinburgh: ["Student Castle Edinburgh"],
    Lincoln: ["Student Castle Lincoln"],
    Oxford: ["Student Castle Oxford"],
    Berkshire: ["Student Castle Reading"],
    York: ["Student Castle York"],
  },
  cloudstudent: {
    Bradford: ["Horton Co-Living", "Horton House", "Longside House"],
    Bolton: ["The Cube"],
    Canterbury: ["Canterbury Student Village"],
    Chester: ["Trinity Hall", "Waterside Court"],
    Huddersfield: ["The Old Chapel"],
    Leicester: ["Highgate", "Tudor Studios"],
    Liverpool: [
      "Falkland House",
      "One Islington Plaza",
      "Pembroke Studios",
      "Phoenix Place",
      "Plato House",
    ],
    Loughborough: ["Foundry 1"],
    Newcastle: ["St Mary's Newcastle"],
    Preston: ["Jubilee Court"],
    Rochester: ["Rochester Student Village"],
    Salford: ["Chapel Street"],
    Sheffield: [
      "London Court",
      "Nebula",
      "Printworks",
      "St Mary's House",
      "Stratus",
    ],
    Stockton: ["Mandale Terrace"],
    "Stoke On Trent": ["Q Studios", "Stoke Student Village"],
    Sunderland: [
      "Dunn House",
      "Millfield House",
      "Norfolk Street",
      "Park Lane House",
      "St Mary's Newcastle",
    ],
  },
  londonist: {
    London: [
      "Drapery Place",
      "Lewisham Exchange",
      "Dashwood Studios",
      "IQ Vega Residence",
      "Paddington Citi View",
      "Seven Sisters",
      "IQ Paris Gardens",
      "IQ Shoreditch",
      "Hawley Crescent",
      "South Bermondsey",
      "IQ Kingston",
      "The Lyra",
      "Islington II",
      "New Cross",
      "Aldgate Residence",
      "Chapter Lewisham Residence",
      "Ealing Residence",
      "IQ Sterling Court",
      "Highbury II Residence",
      "Islington Residence",
      "King's Cross Residence",
      "Old Street Residence",
      "Portobello Residence",
      "South Bank Residence",
      "Spitalfields Residence",
      "Westminster Residence",
      "White City Residence",
      "West Green House",
      "Hackney Wick Park",
      "Therese House",
      "Highbury Residence",
      "Finsbury House",
      "Landale House",
      "Station Court Residence",
      "London Bridge Residence",
      "Stapleton House",
      "Ivy Halls",
    ],
  },
  moda: {
    Birmingham: ["The Mercian", "Loudon's Yard", "Great Charles Street"],
    "Brighton & Hove": ["Hove Central"],
    Edinburgh: ["The Mcewan"],
    Glasgow: ["Holland Park", "Lancefield Quay"],
    Leeds: ["New York Square"],
    Liverpool: ["The Lexington"],
    London: ["Embassy Boulevard", "Penarth Street"],
    Manchester: ["Angel Gardens"],
    York: ["Heworth Green"],
  },
  milestone: {
    Aachen: ["Milestone Aachen West Neubau", "Aachen West Neubau"],
    Bonn: ["Milestone Bonn Beuel", "Beuel"],
    Carcavelos: [
      "Milestone Carcavelos Nova",
      "Milestone Carcavelos Lombos",
      "MILESTONE by Tribera in Lombos",
      "MILESTONE by Tribera in Nova",
      "Lombos",
      "Nova",
    ],
    Copenhagen: ["BaseStack Bryggen"],
    Dortmund: ["Basecamp Dortmund"],
    Gdańsk: [""],
    Göttingen: ["Basecamp Göttingen"],
    Graz: ["Milestone Graz Lend", "Lend"],
    Kraków: [""],
    Leoben: ["Milestone Leoben Montan", "Montan"],
    Linz: ["Milestone Linz Brucknerstudios", "Brucknerstudios"],
    Lisbon: ["Milestone Lisbon Olaias", "Olaias"],
    Milan: [""],
    Rotterdam: ["MILESTONE by Tribera in Chapter Lucia", "Chapter Lucia"],
    Vienna: [
      "Milestone Vienna Erdberg",
      "Milestone Vienna Campus",
      "Milestone Vienna Prater",
      "MILESTONE by Tribera in Campus",
      "MILESTONE by Tribera in Erdberg",
      "MILESTONE by Tribera in Prater",
      "Tribera Erdberg",
      "Campus",
      "Erdberg",
      "Prater",
    ],
    Warsaw: ["Tribera Warsaw", "Mokotow"],
    Wrocław: [
      "Milestone Wrocław Ołbin",
      "Milestone Wrocław Fabryczna",
      "MILESTONE by Tribera in Fabryczna",
      "MILESTONE by Tribera in Ołbin",
      "Fabryczna",
      "Olbin",
    ],
  },
  universalstudentliving: {
    Aberdeen: [],
    Bangor: ["Llys Y Deon", "Neuadd Kyffin", "Ty Ni"],
    Birmingham: ["Lucas Studios", "The Recording Rooms"],
    Bournemouth: ["Mercury House"],
    Canterbury: ["Parham Student Village"],
    Coventry: ["Red Queen"],
    Derby: ["Northgate House"],
    Edinburgh: ["200 Cowgate"],
    "Kingston Upon Thames": [],
    London: ["Academic House", "Fulham Palace Studios"],
    "Newcastle Upon Tyne": ["Albert Place"],
    Nottingham: ["The Rise"],
    Plymouth: ["St Augustine's House"],
    Preston: [],
    Sheffield: ["The Pinnacles"],
    Warwick: [],
    Wolverhampton: ["Chambers 51"],
  },
  essentialstudentliving: {
    Brighton: [],
    Coventry: [],
    "High Wycombe": [],
    Leeds: ["Mary Morris House"],
    Leicester: [],
    Lincoln: [],
    Liverpool: [],
    London: ["Brooke Hall", "Dean House"],
    Manchester: ["Ashton House"],
    "Newcastle Upon Tyne": [],
  },
  evostudent: {
    Colchester: ["Hythe Mills"],
    Guildford: ["Guilden Village Stoke Park"],
    Leeds: [],
    Loughborough: ["Luxurio"],
    Nottingham: ["Arcadian", "Centre Court", "The Vantage"],
    Sheffield: ["Steel City"],
  },
  urbanstudentlife: {
    Bolton: [],
    Canterbury: [],
    Leeds: [],
    Liverpool: [],
    Loughborough: ["The Print House"],
    "Newcastle Upon Tyne": ["Opto"],
    "Newcastle Under Lyme": [
      "Hassell's Bridge Apartments",
      "Keele House",
      "One London Road",
      "Orme House",
    ],
    Nottingham: [],
    Preston: ["Leighton Hall", "Sizer Court"],
    Sheffield: [],
    "Stoke On Trent": ["Aire"],
  },
  prestigestudentliving: {
    Aberdeen: ["Justice Mill Studios"],
    Bath: ["Hollis Wharf"],
    Belfast: ["Aster House", "Ryan Hall", "The Edge"],
    Birmingham: [
      "800 Bristol Road",
      "88 Bromsgrove House",
      "Chamberlain Place",
      "Bridge Street Studios",
      "Compass",
      "Globe Works",
      "Onyx",
      "Pershore Junction",
      "Volume Works",
    ],
    Brighton: ["Crown House", "Holden Court", "Ravilious House"],
    Bristol: [
      "Dean Street Works",
      "The Port On The Square",
      "The Propeller Quarter",
      "The Quarter House",
      "Timber Yard",
    ],
    Cambridge: ["Scholars View", "Stellaris"],
    Cardiff: ["Howard Gardens", "The Fitzalan"],
    Colchester: [],
    Coventry: ["33 Parkside", "Eden Square", "The Residence"],
    Dundee: [
      "Discovery Studios",
      "Greenmarket Studios",
      "Marketgait Apartments",
      "Parklands",
    ],
    Durham: ["Duresme Court", "St Giles Studios"],
    Edinburgh: [
      "Gateway Apartments",
      "Haymarket Yards",
      "Huxley Studios",
      "Mayfield Residences",
      "McDonald Road",
      "Silk Mill",
      "Straits Meadow",
      "Straits Mile",
      "Straits Place",
      "The Keel Houses",
      "The Malt Works",
      "The Pepper Mill",
    ],
    Egham: ["Straits Garden", "The Garage"],
    Exeter: [
      "Clifford House",
      "Hill View Place",
      "Renslade House",
      "West Gate",
    ],
    Glasgow: [
      "Bridle Works",
      "Broadway Studios",
      "City Wharf",
      "Clyde Court",
      "Foundry Courtyard",
      "Glasgow Citi View",
      "Scotway House",
      "St Vincent Studios",
      "Swan Residences",
    ],
    Guildford: ["Ash Grove Court"],
    Huddersfield: [],
    "Kingston Upon Thames": ["Tribu Kingston"],
    Lancaster: ["Foundry Studios", "The Sail Works"],
    Leeds: [
      "26 Great George Street",
      "Headrow Court",
      "Straits Aire",
      "Symons House",
      "The Fabric Works",
      "The Leather Works",
      "The Priory",
      "The Store House",
      "The Terry Frost Building",
      "Tribeka",
    ],
    Leicester: ["The Aspen"],
    Liverpool: ["Fontenoy Apartments", "Innovo House", "Limelight"],
    London: [
      "ARK Canning Town",
      "Charles Morton Court",
      "Flora Building - Hoxton",
      "Griffon Studios",
      "Grosvenor House",
      "Paddington Citi View",
      "Press House",
      "The Valentine",
      "Venue Studios",
      "Westcombe House",
      "Wick Park",
      "Willen House",
      "Wood Lane Studios",
    ],
    Loughborough: [],
    Manchester: ["St Gabriels Court"],
    "Newcastle Upon Tyne": ["Sheares Hall", "The Glassworks"],
    Nottingham: [
      "Crown Place",
      "Fabric",
      "Miura",
      "Straits Village",
      "The Place",
    ],
    Oxford: ["West Way Square", "Wilson House"],
    Plymouth: ["Saltwater Place"],
    Preston: ["Urban Hub"],
    Reading: ["79 Silver Street"],
    Sheffield: [
      "Crown House",
      "Electric Press",
      "Hannah Court",
      "Hillside House",
      "Loxley Heights",
      "Steelworks",
      "Straits Manor",
    ],
    Southampton: ["Stanley Studios"],
    "Stoke On Trent": ["Icon House"],
    "The Propeller Quarter": [],
    York: ["The Coal Yard", "Waterloo House", "Raffles Hall"],
  },
  hfs: {
    Aberdeen: ["Spring Gardens", "Powis Place", "Causeway View", "Abeleven"],
    Aberystwyth: ["Alexandra Hall"],
    Bangor: [],
    Bath: [],
    Bedford: ["Polhill Park"],
    Belfast: [],
    Birmingham: [
      "Calthorpe Court",
      "Canalside",
      "Selly Oak Court",
      "The Metalworks",
    ],
    Bournemouth: [],
    Bradford: ["The Green"],
    Brighton: ["Alumno Falmer", "Hollingbury House", "Moulsecoomb Place"],
    Bristol: [
      "Centre Gate",
      "Harbour Court",
      "King Square Studios",
      "St Lawrence House",
      "Studio 58",
      "The Colston",
    ],
    Cambridge: [],
    Canterbury: [],
    Cardiff: [],
    Chester: ["Abbeygate"],
    Colchester: ["Uliving Colchester"],
    Coventry: ["The Apollo Works", "Urban Student Village"],
    Derby: ["The Croft"],
    Dublin: ["Aspen"],
    Dundee: [],
    Durham: [],
    Edinburgh: [
      "8 Roxburgh",
      "Beaverbank Place",
      "Haddington Place",
      "The Mill House",
    ],
    Egham: [],
    Exeter: ["Atlas House", "Iron Bridge Studios", "The Printworks"],
    Glasgow: [
      "Firhill Court",
      "Gallery Apartments",
      "Kelvingrove House",
      "Riverside",
    ],
    Gloucester: [],
    Guildford: ["Bankside Student Living", "The Bridge"],
    "High Wycombe": [],
    Huddersfield: [],
    "Kingston Upon Thames": ["Bright House"],
    Lancaster: ["Gillows", "Luneside", "St Leonard's House"],
    "Leamington Spa": [],
    Leeds: ["The Tannery", "Grayson Heights", "Clarence Dock Village"],
    Leicester: [
      "Ben Russell Court",
      "Filbert Village",
      "The Glassworks",
      "Newarke Point",
      "Grange Lane Apartments",
      "St Martins House",
    ],
    Lincoln: ["Brayford Quay", "Danesgate House"],
    Liverpool: [
      "Glassworks",
      "Paddington Park House",
      "St Andrew's Gardens",
      "Windsor Court",
    ],
    London: [
      "Bloomsbury Janet Poole House",
      "Camden Hawley Crescent",
      "Central Studios",
      "Chelsea Lightfoot Hall",
      "Cube Greenwich",
      "Cube Ealing",
      "Halsmere Studios",
      "Portobello Garrow House",
      "Surrey Quays Landale House",
      "The Paragon",
      "Town Hall Camberwell",
    ],
    Loughborough: ["The Cube"],
    Luton: [],
    Manchester: [
      "Allen Court",
      "Daisybank Villas",
      "Heald Court",
      "Manchester Court",
      "Manchester House",
      "Oxney House and Gardens",
      "Park View",
      "Riverside House",
    ],
    "Newcastle Upon Tyne": ["Barker House"],
    Norwich: [],
    Nottingham: [
      "Bowman House",
      "Cotton House",
      "Curzon House",
      "Medici",
      "Nottingham Square",
      "Russell View",
      "The Glasshouse",
    ],
    Oxford: ["Court Place Gardens"],
    Plymouth: ["Frobisher House", "Plymouth Cross House", "The Old Dairy"],
    Preston: ["Foundry Court", "Trinity Student Village"],
    Reading: ["Berkshire House", "Crown House", "Kendrick Hall"],
    Salford: ["Riverside House"],
    Sheffield: [
      "Devonshire Courtyard",
      "Redvers Tower",
      "Rockingham House",
      "The Anvil",
      "The Elements",
      "The Forge",
      "The Paper Works",
    ],
    Southampton: [
      "Emily Davies",
      "Green Wood Court",
      "Hamwic Hall",
      "Marland House",
      "Queens Gate",
      "The Court Yard",
    ],
    "St Andrews": ["East Shore"],
    Stirling: [],
    "Stockton-On-Tees (Durham ISC)": [],
    "Stoke-On-Trent": ["College Court"],
    Warwick: [],
    Wolverhampton: [],
    Worcester: [],
    York: ["Abode"],
  },
  studentfm: {
    Chester: ["Northgate Studios", "Northgate Point"],
    Lancaster: ["Silk Mill"],
    Leeds: ["Woodhouse Flats"],
    Manchester: ["Q3 Apartments"],
    Newcastle: ["Burgess House"],
    "Newcastle Under Lyme": ["The Metropolis"],
    Nottingham: [
      "The Laceworks",
      "The Farthings",
      "Avalon Court",
      "Minerva House",
    ],
    Preston: ["The Tramshed"],
    Sheffield: ["Aspect 3", "Sovereign House", "Nebula House", "Newbank House"],
    Sunderland: ["Clanny House"],
    Leicester: ["Primus Place", "Edge Apartments"],
  },
  capitolstudents: {
    Bristol: ["Culver House", "Transom House"],
    Colchester: ["The Maltings"],
    Coventry: ["Calcott Ten", "Millennium View"],
    Warwick: ["Westwood Student Mews"],
    Edinburgh: ["Gorgie", "Westfield"],
    Glasgow: ["Clifton & Stewart House"],
    Huddersfield: ["Snow Island", "Saw Mill", "Firth Point"],
    Leeds: ["Asa Briggs House"],
    London: ["Bernard Myers", "Sunlight Apartments"],
    Norwich: ["Pablo Fanque House"],
    Plymouth: [
      "Alexandra Works",
      "Central Point",
      "Discovery Heights",
      "St. Teresa House",
      "St. Thomas Court",
    ],
    Sheffield: ["Central Quay", "Sharman Court"],
    Southampton: ["Hampton Square"],
    Bremen: ["Galileo Residenz"],
  },
  hellohomie: {
    Durham: [
      "Ash Tree House",
      "12 Brierville",
      "15 Neville Terrace",
      "51 Highgate",
      "Holly Tree House",
      "7 Highgate",
      "13 Neville Terrace",
      "14 Neville Terrace",
      "23 Long Acres",
      "33 Long Acres",
    ],
    Leeds: [
      "7 Welton Place",
      "23 Kelso Road",
      "79B Cardigan Road",
      "79A Cardigan Road",
      "39 Royal Park Road",
      "27 Mayville Road",
      "19 Welton Place",
      "16 Mayville Street",
      "16 Chestnut Avenue",
      "139 Brudenell Road",
      "15 Beamsley Grove",
      "19 Hyde Park Terrace",
      "23 Kelso Gardens",
      "Flat 1, 205 Belle Vue Road",
      "Flat 2, 205 Belle Vue Road",
      "Flat 3, 205 Belle Vue Road",
      "Flat 4, 205 Belle Vue Road",
      "124 Belle Vue Road",
      "Flat 1, 152 Otley Road",
      "Lower Flat, 152 Otley Road",
      "33 Ash Grove",
      "35 Ash Grove",
      "43 Ash Grove",
      "2 Brudenell Mount",
      "23 Manor Terrace",
      "5a Chestnut Avenue",
      "5b Chestnut Avenue",
      "105 Victoria Road",
      "17 Royal Park Terrace",
      "9 Ash Grove",
      "Flat 3, 152 Otley Road",
      "46 Ash Grove",
    ],
    Manchester: [
      "25 Lindleywood Road",
      "11 Lindleywood Road",
      "40 Kingswood Road",
      "35 Kingswood Road",
      "6, 2 Palatine Mews",
      "27 Monica Grove",
      "9 Fairview Avenue",
      "28 Wald Avenue",
      "54 Finchley Road",
      "20 Fairview Avenue",
      "69 St. Ives Road",
      "79 St. Ives Road",
      "17 Edenhall Avenue",
      "29 Edenhall Avenue",
      "14 Colgate Crescent",
      "71 St. Ives Road",
    ],
    Newcastle: [
      "Flat A1, Leazes Parade",
      "Flat A2, Leazes Parade",
      "Flat B1, Leazes Parade",
      "Flat B2, Leazes Parade",
      "Flat C1, Leazes Parade",
      "Flat D1, Leazes Parade",
      "Flat D2, Leazes Parade",
      "Flat E1, Leazes Parade",
      "Flat E2, Leazes Parade",
      "Flat F1, Leazes Parade",
      "Flat F2, Leazes Parade",
      "Flat G2, Leazes Parade",
      "Flat H1, Leazes Parade",
      "Flat H2, Leazes Parade",
      "Flat P1, Leazes Parade",
      "Flat P5, Leazes Parade",
      "Flat P6, Leazes Parade",
      "Flat P7, Leazes Parade",
      "Flat P8, Leazes Parade",
      "Flat P9, Leazes Parade",
      "Flat P12, Leazes Parade",
      "Flat I2, Leazes Parade",
      "Flat J2, Leazes Parade",
      "Flat L2, Leazes Parade",
      "Flat M1, Leazes Parade",
      "Flat O3, Leazes Parade",
      "Flat P2, Leazes Parade",
      "Flat P11, Leazes Parade",
      "Flat J1, Leazes Parade",
      "Flat L1, Leazes Parade",
      "Flat M2, Leazes Parade",
      "Flat O4, Leazes Parade",
      "Flat O5, Leazes Parade",
      "Flat O6, Leazes Parade",
      "Flat P13, Leazes Parade",
      "Flat P14, Leazes Parade",
      "Flat P16, Leazes Parade",
      "Flat P17, Leazes Parade",
      "Flat P18, Leazes Parade",
      "Flat C2, Leazes Parade",
      "Flat G1, Leazes Parade",
      "Flat G3, Leazes Parade",
      "Flat I1, Leazes Parade",
      "Flat K1, Leazes Parade",
      "Flat N2, Leazes Parade",
      "Flat P3, Leazes Parade",
      "Flat K2, Leazes Parade",
      "Flat N1, Leazes Parade",
      "Flat P15, Leazes Parade",
    ],
  },
  propertysense: {
    Birmingham: [
      "Apt - 1113 The Whitmore Collection",
      "Apt - 2002 The Whitmore Collection",
      "Apt - 2205 The Whitmore Collection",
      "Apt - 4403 The Whitmore Collection",
      "Guild Point SHERLOCK QUARTER",
      "Mitton House SHERLOCK QUARTER",
      "Sadlers Place SHERLOCK QUARTER",
      "The Whitmore Collection",
    ],
    Bracknell: ["Tangmere Mews, Broad Lane"],
    Cardiff: [
      "Apt - 0414 PLATFORM CARDIFF",
      "Apt - 105 PLATFORM CARDIFF",
      "Apt - 126 ANCHOR WORKS",
      "Apt - 325 ANCHOR WORKS",
      "Apt - 503 PLATFORM CARDIFF",
      "Apt - 509 ANCHOR WORKS",
      "Apt - 6 ANCHOR WORKS",
      "Apt - 8 ANCHOR WORKS",
      "Lloyds House ANCHOR WORKS",
      "PLATFORM CARDIFF",
    ],
    ECCLES: [
      "Apt - 122 CHURCH STREET PLACE",
      "Apt - 1503 CHURCH STREET PLACE",
      "Apt - 1608 CHURCH STREET PLACE",
      "Apt - 215 CHURCH STREET PLACE",
      "Apt - 311 CHURCH STREET PLACE",
      "Apt - 604 CHURCH STREET PLACE",
    ],
    Glasgow: [
      "Apt - 402 30 Anderston Quay",
      "Apt - 615 Warroch Place",
      "Warroch Place",
    ],
    "Kingston upon Thames": ["Apt - 311 Tribu", "Tribu"],
    Leatherhead: [
      "Apt - 177 THE OAKGATE",
      "Apt - 179 THE OAKGATE",
      "Apt - 30 THE OAKGATE",
      "Apt - 88 THE OAKGATE",
      "Apt 204 THE OAKGATE",
      "THE OAKGATE",
    ],
    London: [
      "Apt - 310 The Apiary",
      "Apt - 601 The Apiary",
      "Apt - 606 The Apiary",
      "The Apiary",
    ],
    Maidenhead: [
      "Francis House ONE MAIDENHEAD",
      "Hornby House ONE MAIDENHEAD",
      "Lofting House ONE MAIDENHEAD",
    ],
    Manchester: [
      "Apt - 0312 Swan Street House",
      "Apt - 2907 Swan Street House",
      "Apt - 312 Swan Street House",
      "Apt 1607 Swan Street House",
      "The Interchange, Daw Bank",
    ],
    Nottingham: ["Medici, Hockley"],
    Salford: [
      "APT - 712 NEW MAKER YARDS",
      "Apartment - 0014 NEW MAKER YARDS",
      "Apt - 0404 NEW MAKER YARDS",
      "Apt - 103 NEW MAKER YARDS",
      "Apt 313 NEW MAKER YARDS",
      "NEW MAKER YARDS",
    ],
    Sheffield: [
      "Apartment -0416 The Ironworks",
      "Apt - 0702 The Ironworks",
      "Apt - 1002 The Ironworks",
      "Apt - 1007 The Ironworks",
      "Apt - 419 The Ironworks",
      "Apt - 610 The Ironworks",
      "Apt 65 Furnival Square",
      "Apt 905 Sylvester Street",
      "Sylvester Street",
    ],
    Staines: [
      "Apt - 36 Riverview",
      "Apt - 37 Riverview",
      "Apt 86 Riverview",
      "Riverview",
    ],
  },
  ypp: {
    Bristol: ["Yelland House"],
    Harrogate: [
      "53 East Parade",
      "Pavilion House",
      "51 East Parade",
      "47-49 East Parade",
    ],
    Leeds: [
      "15 Providence Place",
      "162 Woodhouse Lane",
      "495A Otley Road",
      "Fairbairn Residence",
      "29 Clarendon Road",
      "Live Oasis St Albans Place",
      "19 Regent Park Terrace",
      "Q One Residence",
      "14 Belle Vue Court",
      "27 Blenheim View",
      "Q Three Residence",
      "Crown Residence",
      "8 Blenheim Terrace",
      "18 Queen Square",
      "23 Hyde Terrace",
      "17 Queen Square",
      "Churchill House Residence",
      "Park Square Residence",
      "5 South Parade",
      "Live Oasis Eastgate",
      "25 Springfield Mount",
      "7 South Parade",
      "25 Hyde Terrace",
      "Ribbon Residence",
      "Live Oasis Wade Lane",
      "Lofthouse Residence",
      "Live Oasis Belgrave Street",
      "8 Queen Square",
      "103 Silk Mill Drive",
      "21 Servia Drive",
      "25 Carlton View",
      "497 Otley Road",
      "28 Woodbridge Green",
      "11 Kelsall Road",
      "4 Darnley Road",
      "30 Brudenell Road",
      "27 Hyde Terrace",
      "31 Clarendon Road",
      "Woodhouse Plaza",
      "21 Hyde Terrace",
      "215 Belle Vue Road",
      "12A Clarendon Road",
      "16 St John's Terrace",
      "29 Springfield Mount",
      "4 St John's Terrace",
      "21 Springfield Mount",
      "19 Springfield Mount",
      "34 Hyde Terrace",
      "27 Springfield Mount",
      "8 Springfield Mount",
      "Live Oasis Merrion Street Gardens",
      "11 Bedford Green",
      "Oasis Residence",
      "Clarendon House",
      "Havana Residence",
      "23 Springfield Mount",
      "Portland Place",
      "Q Two Residence",
      "41 St Paul's Street",
      "40 Clarendon Road",
      "17-21 Cookridge Street",
      "18 East Parade",
      "113 The Headrow",
      "23 Butts Court",
      "22A Blenheim Terrace",
    ],
    Liverpool: ["Gravity Residence"],
    London: ["Manor House", "1 Circus Lodge", "Castello Court"],
    Manchester: [
      "Live Oasis Piccadilly",
      "Live Oasis Deansgate",
      "Eagle House",
      "Wellington Road",
      "Waterloo Street",
      "25 Cross Street",
      "Cambridge House",
    ],
    Sheffield: ["Onyx Residence"],
    York: ["Fossgate House", "George House", "Piccadilly Residence"],
  },
  neostudents: {
    Canterbury: ["Currus Court", "Rhodaus Court", "Palamon Court"],
  },
  almerostudent: {
    Birmingham: ["B16 Studios", "Beech Gardens"],
    Bristol: ["Tamarillo House", "Stonebridge House"],
    Exeter: ["New North Road", "Blockyard Apartments"],
    Leeds: ["Thornville Court", "Welton Road", "Hyde Park", "Royal Park Road"],
    London: ["Francis Gardner"],
    Manchester: ["Ladybarn House"],
    Newcastle: ["Quayside Court"],
    Nottingham: ["Madison Gardens"],
    Oxford: ["The Park"],
    York: ["Holgate Road"],
  },
  nowstudents: {
    Aberdeen: ["Caledon Court"],
    Bath: ["Avon Studios"],
    Birmingham: ["Jennens Court"],
    Bournemouth: ["Oxford Point", "Skyline"],
    Canterbury: ["Alma Court"],
    Cardiff: ["Bridge Street Exchange", "North Court"],
    Leicester: ["The Grange"],
    Liverpool: ["Prospect Point"],
    Newcastle: ["Market House"],
    Nottingham: ["St Peters Court"],
    Oxford: ["Between Towns Court"],
    Sheffield: ["Bailey Fields", "Exchange Works"],
    Southampton: ["Portswood House"],
  },
  truestudent: {
    Birmingham: [],
    Glasgow: [],
    Leicester: [],
    Liverpool: [],
    Salford: [],
    Nottingham: [],
    Sheffield: [],
    Swansea: [],
  },
  yourtribe: {
    London: [
      "YourTRIBE Southwark",
      "YourTRIBE South Bermondsey",
      "YourTRIBE Deptford",
      "YourTRIBE Elephant & Castle",
    ],
  },
  lunastudents: {
    Leeds: ["Burley Studios", "Trapezium"],
    Coventry: ["Burnsall House"],
    Nottingham: ["Bridgeside", "Medici"],
  },
  mansionstudent: {
    Cardiff: ["City Heights"],
    Coventry: ["Singer Hall"],
    Dundee: ["Peterson Hall"],
    Durham: ["Ernest Place"],
    Edinburgh: ["Goods Corner"],
    Exeter: ["Exeter One"],
    "Leamington Spa": ["The Union"],
    Leeds: ["Austin Hall", "Asquith House"],
    Leicester: ["Dover Street Apartments"],
    Manchester: ["Moss Court", "City Edge"],
  },
  iconinc: {
    Leeds: ["The Glassworks", "The Edge", "Triangle"],
    Liverpool: ["The Ascent"],
    Lincoln: ["Gravity"],
    Glasgow: ["The Bonnie"],
    Newcastle: ["Newcastle City"],
    Manchester: ["Manchester Victoria"],
    York: ["York City"],
    London: ["London Stratford", "Southall"],
    Nottingham: ["Nottingham City"],
    Chester: ["Chester City"],
  },
  aparto: {
    Aberdeen: ["The Combworks"],
    Brighton: ["Vogue Studios", "Stoneworks"],
    Bristol: ["Brigg Point"],
    Cambridge: ["The Cam Foundry"],
    Glasgow: ["Glasgow West End"],
    Kingston: ["Arbury Court"],
    Lancaster: ["Caton Court"],
    Oxford: ["The Spireworks"],
    Reading: ["Queens Court"],
    Barcelona: ["Pallars", "Cristóbal De Moura", "Diagonal Suites"],
    Milan: ["Giovenale", "Ripamonti", "Durando"],
    Bologna: ["San Vitale"],
    Florence: ["Manifattura", "Rifredi"],
    Dublin: [
      "Binary Hub",
      "Beckett House",
      "Dorset Point",
      "The Loom",
      "Montrose",
      "Stephen's Quarter",
    ],
    Paris: ["Paris Liberté"],
  },
  pfpstudents: {
    Cambridge: ["Brunswick House"],
    Sheffield: ["Beton House"],
    Glasgow: ["Hyndland House"],
    Egham: ["Parish Hall", "Virginia House"],
  },
  collegiateeu: {
    Birmingham: ["Bagot Street", "Chamberlain Place"],
    Bristol: ["Tower"],
    Cardiff: ["Eclipse", "Crown Place"],
    Cheltenham: ["Shaftesbury Hall"],
    Derby: ["Roman House"],
    Edinburgh: ["Silk Mill"],
    Exeter: ["Point Exe", "Bonhay House", "King Edward Studios"],
    Glasgow: ["Bridle Works"],
    Gloucester: ["Upper Quay House"],
    Ipswich: ["Athena Hall"],
    Leicester: ["Merlin Heights"],
    London: ["Dashwood Studios"],
    Madrid: ["Chamartin"],
    Milan: ["Milan North", "Milan Bovisa"],
    Wembley: ["Pavillion Court"],
    Newcastle: ["Plummer House"],
    Norwich: ["Crown Place"],
    Nottingham: ["Nova"],
    Portsmouth: [
      "Crown Place",
      "Earlsdon Street",
      "Middle Street",
      "St James Street",
    ],
    Sheffield: ["Hillside House"],
    Southampton: ["Park House"],
    Winchester: ["Cathedral Point", "Riverside Way"],
    Chester: ["Tudor Place", "Granary Studios"],
    Colchester: [
      "The Meadows",
      "The Copse",
      "The Pastures",
      "University Quays",
    ],
  },
};

export const cityNameReplacerConfig: Record<string, Record<string, string>> = {
  unionatmidtown: {
    "Union At Midtown": "Union At Midtown",
  },
  unionatdearborn: {
    "Union At Dearborn": "Union At Dearborn",
  },
  milestone: {
    Gdansk: "Gdańsk",
    Krakow: "Kraków",
    Wroclaw: "Wrocław",
    Vienna: "Vienna",
    Graz: "Graz",
    Linz: "Linz",
    Leoben: "Leoben",
    Goettingen: "Göttingen",
  },
  prestigestudentliving: {
    "The Propeller Quarter 2": "The Propeller Quarter",
  },
  moda: {
    "Brighton And Hove": "Brighton & Hove",
  },
  hfs: {
    "Stockton On Tees": "Stockton-On-Tees (Durham ISC)",
    "Stoke On Trent": "Stoke-On-Trent",
  },
  collegiateeu: {
    "Alloggi Studenti Milan": "Milan",
    milan: "Milan",
  },
  studentfm: {
    "Clanny House Sunderland": "Sunderland",
    "Woodhouse Flats Leeds": "Leeds",
  },
  ypp: {
    "Lifestyle Bristol": "Bristol",
    "Explore City Harrogate": "Harrogate",
    "Leeds Lifestyle": "Leeds",
    "Explore City Liverpool": "Liverpool",
    "Explore City London": "London",
    "Explore City Manchester": "Manchester",
    "Explore City Sheffield": "Sheffield",
    "Explore City York": "York",
  },
  neostudents: {
    "Canterbury Student Accommodation": "Canterbury",
  },
  almerostudent: {
    Newcastle: "Newcastle",
  },
  nowstudents: {
    Newcastle: "Newcastle",
  },
  aparto: {
    "Kingston London": "Kingston",
  },
};

export const propertyNameReplacerConfig: Record<
  string,
  Record<string, string>
> = {
  universalstudentliving: {
    "St Augustines House": "St Augustine's House",
  },
  londonist: {
    "Kings Cross Residence": "King's Cross Residence",
  },
  cloudstudent: {
    "St Marys Newcastle": "St Mary's Newcastle",
    "St Marys House": "St Mary's House",
    "Horton Co Living": "Horton Co-Living",
  },
  milestone: {
    "Milestone Gdansk Center": "Milestone Gdańsk Center",
    "Milestone Krakow": "Milestone Kraków Center",
    "Milestone Wroclaw Olbin": "Milestone Wrocław Ołbin",
    "Wroclaw Fabryczna": "Milestone Wrocław Fabryczna",
    "Milestone Vienna Erdberg": "MILESTONE Vienna Erdberg",
    "Milestone Vienna Campus": "MILESTONE Vienna Campus",
    "Milestone Vienna Prater": "MILESTONE Vienna Prater",
    "Milestone Graz Lend": "MILESTONE Graz Lend",
    "Milestone Linz Brucknerstudios": "MILESTONE Linz Brucknerstudios",
    "Milestone Leoben Montan": "MILESTONE Leoben Montan",
    "Graz Lend Student Accommodation": "Lend",
    "Leoben Montan Student Accommodation": "Montan",
    "Linz Brucknerstudio Student Accommodation": "Brucknerstudios",
    "Vienna Campus Student Accommodation": "Campus",
    "Vienna Erdberg Student Accommodation": "Erdberg",
    "Vienna Prater Student Accommodation": "Prater",
    "Vienna Erdberg Coliving": "Tribera Erdberg",
    "Student Accommodation": "BaseStack Bryggen",
    "Aachen Neubau Student Accommodation": "Aachen West Neubau",
    "Bonn Beuel Student Accommodation": "Beuel",
    "Milan Student Accommodation": "",
    "Chapter Lucia Student Accommodation": "Chapter Lucia",
    "Gdansk Center Student Accommodation": "MILESTONE by Tribera",
    "Krakow Center Student Accommodation": "MILESTONE by Tribera",
    "Warsaw Mokotow Student Accommodation": "Mokotow",
    "Wroclaw Fabryczna Student Accommodation": "Fabryczna",
    "Wroclaw Olbin Student Accommodation": "Olbin",
    "Carcavelos Lombos Student Accommodation": "Lombos",
    "Carcavelos Nova Student Accommodation": "Nova",
    "Lisbon Olaias Student Accommodation": "Olaias",
  },
  evostudent: {
    "Guilden Village": "Guilden Village Stoke Park",
  },
  urbanstudentlife: {
    "Hassells Bridge Apartments": "Hassell's Bridge Apartments",
  },
  prestigestudentliving: {
    "Ark Canning Town": "ARK Canning Town",
    "Mcdonald Road": "McDonald Road",
    "Flora Building": "Flora Building - Hoxton",
  },
  moda: {
    "Loudons Yard": "Loudon's Yard",
  },
  hfs: {
    "St Leonards House": "St Leonard's House",
    "St Andrews Gardens": "St Andrew's Gardens",
  },
  collegiateeu: {
    "Collegiate Madrid Chamartin": "Chamartin",
    "Collegiate Milan North": "Milan North",
    "Collegiate Milan Bovisa": "Milan Bovisa",
    "Milan Bovisa": "Milan Bovisa",
  },
  capitolstudents: {
    "Clifton Stewart House": "Clifton & Stewart House",
    "St Teresa House": "St. Teresa House",
    "St Thomas Court": "St. Thomas Court",
  },
  hellohomie: {
    "P5 Leazes Parade": "Flat P5, Leazes Parade",
    "P6 Leazes Parade": "Flat P6, Leazes Parade",
    "P7 Leazes Parade": "Flat P7, Leazes Parade",
    "P8 Leazes Parade": "Flat P8, Leazes Parade",
    "P9 Leazes Parade": "Flat P9, Leazes Parade",
    "P12 Leazes Parade": "Flat P12, Leazes Parade",
    "P2 Leazes Parade": "Flat P2, Leazes Parade",
    "P11 Leazes Parade": "Flat P11, Leazes Parade",
    "7 Welton Place 2": "7 Welton Place",
    "79b Cardigan Road": "79B Cardigan Road",
    "79a Cardigan Road 2": "79A Cardigan Road",
    "Flat 2, 205 Belle Vue Road 2": "Flat 2, 205 Belle Vue Road",
    "Flat 2, 152 Otley Road": "Lower Flat, 152 Otley Road",
    "5b Chestnut Avenue 2": "5b Chestnut Avenue",
    "6 2 Palatine Mews": "6, 2 Palatine Mews",
    "69 St Ives Road": "69 St. Ives Road",
    "79 St Ives Road": "79 St. Ives Road",
    "71 St Ives Road": "71 St. Ives Road",
  },
  studentfm: {
    "Clanny House Sunderland": "Clanny House",
    "Woodhouse Flats Leeds": "Woodhouse Flats",
  },
  ypp: {
    "4 St John S Terrace": "4 St John's Terrace",
    "16 St John S Terrace": "16 St John's Terrace",
    "22a Blenheim Terrace": "22A Blenheim Terrace",
    "41 St Paul S Street": "41 St Paul's Street",
    "495a Otley Road": "495A Otley Road",
    "47 49 East Parade": "47-49 East Parade",
    "12a Clarendon Road": "12A Clarendon Road",
    "17 21 Cookridge Street": "17-21 Cookridge Street",
  },
  almerostudent: {
    "B 16 Studios": "B16 Studios",
    "B16 Studios Student Accommodation": "B16 Studios",
    "Beech Gardens Student Accommodation": "Beech Gardens",
    "Tamarillo House Student Accommodation": "Tamarillo House",
    "Stonebridge House Student Accommodation": "Stonebridge House",
    "New North Road Student Accommodation": "New North Road",
    "Blockyard Apartments Student Accommodation": "Blockyard Apartments",
    "Thornville Court Student Accommodation": "Thornville Court",
    "Welton Road Student Accommodation": "Welton Road",
    "Hyde Park Student Accommodation": "Hyde Park",
    "Royal Park Road Student Accommodation": "Royal Park Road",
    "Francis Gardner Student Accommodation": "Francis Gardner",
    "Ladybarn House Student Accommodation": "Ladybarn House",
    "Quayside Court Student Accommodation": "Quayside Court",
    "Madison Gardens Student Accommodation": "Madison Gardens",
    "The Park Student Accommodation": "The Park",
    "Holgate Road Student Accommodation": "Holgate Road",
  },
  nowstudents: {
    "St Peters Court": "St Peters Court",
    "St Peter S Court": "St Peters Court",
    "Prospect Point.": "Prospect Point",
    "Between Towns Court": "Between Towns Court",
  },
  yourtribe: {
    "Elephant And Castle": "Elephant & Castle",
  },
  lunastudents: {
    "Burley Studios": "Burley Studios",
    "Burnsall House": "Burnsall House",
  },
  mansionstudent: {
    "Lms The Union": "The Union",
    "Cov Singer Hall": "Singer Hall",
    "Dun Peterson Hall": "Peterson Hall",
    "Mcr Moss Court": "Moss Court",
    "Edi Goods Corner": "Goods Corner",
    "Ext Exeter One": "Exeter One",
    "Drm Ernest Place": "Ernest Place",
    "Lei Dover Street": "Dover Street Apartments",
    "Cdf City Heights": "City Heights",
    "Mcr City Edge": "City Edge",
    "Lds Austin Hall": "Austin Hall",
    "Lds Asquith House": "Asquith House",
  },
  aparto: {
    "Cristobal De Moura": "Cristóbal De Moura",
    "Stephens Quarter": "Stephen's Quarter",
    Liberte: "Paris Liberté",
  },
};

const aachenWestNeubauConfig = {
  city: "Aachen",
  property: "Milestone Aachen West Neubau",
};

const bonnBeuelConfig = {
  city: "Bonn",
  property: "Milestone Bonn Beuel",
};

const carcavelosNovaConfig = {
  city: "Carcavelos",
  property: "Milestone Carcavelos Nova",
};

const carcavelosLombosConfig = {
  city: "Carcavelos",
  property: "Milestone Carcavelos Lombos",
};

const krakowCenterConfig = {
  city: "Kraków",
  property: "Milestone Kraków Center",
};

const wroclawOlbinConfig = {
  city: "Wrocław",
  property: "Milestone Wrocław Ołbin",
};

const viennaErdbergConfig = {
  city: "Vienna",
  property: "MILESTONE Vienna Erdberg",
};

const viennaCampusConfig = {
  city: "Vienna",
  property: "MILESTONE Vienna Campus",
};

const viennaPraterConfig = {
  city: "Vienna",
  property: "MILESTONE Vienna Prater",
};

const grazConfig = {
  city: "Graz",
  property: "MILESTONE Graz Lend",
};

const linzConfig = {
  city: "Linz",
  property: "MILESTONE Linz Brucknerstudios",
};

const leobenConfig = {
  city: "Leoben",
  property: "MILESTONE Leoben Montan",
};

export const searchParamsReplacerConfig: Record<
  string,
  Record<string, { city: string; property: string }>
> = {
  milestone: {
    "BUILDING:GDANSKCENTER;": {
      city: "Gdańsk",
      property: "Milestone Gdańsk Center",
    },
    "BUILDING:MILESTONE_KRAKOW_CENTER;": krakowCenterConfig,
    "BUILDING:KARCENPRM;": krakowCenterConfig,
    "AREA:LISBON": {
      city: "Lisbon",
      property: "Milestone Lisbon Olaias",
    },
    "BUILDING:MILEFab;": {
      city: "Wrocław",
      property: "Milestone Wrocław Fabryczna",
    },
    "AREA:WROCLAW;BUILDING:WORCOLBIN;PROPERTYTYPE:STDAPART;":
      wroclawOlbinConfig,
    "PROPERTYTYPE:LOFTAPARTSINGLE;AREA:WROCLAW;BUILDING:WORCOLBIN;":
      wroclawOlbinConfig,
    "PROPERTYTYPE:APTLOFT2;AREA:WROCLAW;BUILDING:WORCOLBIN;":
      wroclawOlbinConfig,
    "AREA:WROCLAW;BUILDING:WORCOLBIN;": wroclawOlbinConfig,
    "PROPERTYTYPE:STD2COMM;PROPERTYTYPE:STD3COMM;AREA:WROCLAW;BUILDING:WORCOLBIN;":
      wroclawOlbinConfig,
    "AREA:WROCLAW;BUILDING:WORCOLBIN;PROPERTYTYPE:COMMSHARE2;":
      wroclawOlbinConfig,
    "PROPERTYTYPE:COMMUNITY DELUXE DOUBLE;AREA:WROCLAW;BUILDING:WORCOLBIN;":
      wroclawOlbinConfig,
    "AREA:LISSABON;BUILDING:CAS01;": carcavelosNovaConfig,
    "AREA:LISSABON;BUILDING:CAS02;": carcavelosLombosConfig,
    "PROPERTYTYPE:STDAPART;BUILDING:ACHWESTNEU;": aachenWestNeubauConfig,
    "BUILDING:MILEBONN;": bonnBeuelConfig,
    "PROPERTYTYPE:STDAPART;AREA:VIENNA;BUILDING:VIE01;": viennaPraterConfig,
    "PROPERTYTYPE:STDAPART;AREA:VIENNA;BUILDING:VIE02;": viennaCampusConfig,
    "PROPERTYTYPE:STDAPART;AREA:VIENNA;BUILDING:VIEERD;": viennaErdbergConfig,
    "PROPERTYTYPE:STDAPART;AREA:GRAZ;": grazConfig,
    "PROPERTYTYPE:STDCOMM;AREA:LINZ;": linzConfig,
    "PROPERTYTYPE:STDCOMM;AREA:LEOBEN;": leobenConfig,
  },
};

export const clientsWithPostFormQuestions = ["scape", "moda"];

export const clientsWithFloorInfo = ["thepodium", "theslateyard" , "wayoflife"];

export const clientsWithCampusInfo = ["lse"];

export const clientsWithPriceRange = ["lse"];

export const clientsWithSqftInfo = [
  "thepodium",
  "theslateyard",
  "hercurlallsop",
  "packagedliving",
  "vivuskwallsop",
  "urbanandcivicallsop",
  "wayoflife"
];

export const clientsWithAvailableFromOverride = ["thepodium", "theslateyard"];

export const roomTypeLabelConfig: Record<string, string> = {
  thepodium: "Apartment",
  theslateyard: "Apartment",
  wayoflife: "Apartment Type",
  emporiumhouse: "Apartment Type",
  hercurlallsop: "House Type",
  packagedliving: "House Type",
  vivuskwallsop: "House Type",
  urbanandcivicallsop: "House Type",
};

export const clientsWithDateReformat = [
  "hercurlallsop",
  "packagedliving",
  "vivuskwallsop",
  "urbanandcivicallsop",
  "una",
];

export const featuresLabelConfig: Record<string, string> = {
  hercurlallsop: "House Features",
  packagedliving: "House Features",
  vivuskwallsop: "House Features",
  urbanandcivicallsop: "House Features",
};

export const disableCommunicationRedirects = {
  clients: ["vita"],
  vita: [
    "https://www.vitastudent.com/en/cities/madrid/",
    "https://www.vitastudent.com/en/cities/madrid/oria/",
    "https://www.vitastudent.com/en/cities/birmingham/gough-street/",
    "https://www.vitastudent.com/en/cities/edinburgh/new-waverley/",
    "https://www.vitastudent.com/en/cities/newcastle/leazes-park/",
  ],
};

export const disableWidget: {
  clients: string[];
  [key: string]: string[] | string[];
} = {
  clients: ["verbaflo"],
  verbaflo: [
    "https://www.verbaflo.ai/book-a-demo/realestate",
    "https://www.verbaflo.ai/book-a-demo/realestate-uk",
  ],
};

export const COMMUNICATION_REDIRECTS_RIGHT_ALIGNMENT = [
  "ypp",
  "londonist",
  "fusiongroup",
  "downing",
  "downingstudents",
  "almerostudent",
  "nowstudents",
  "truestudent",
  "iconinc",
  "universalstudentliving",
  "urbanstudentlife",
  "prestigestudentliving",
  "essentialstudentliving",
  "evostudent",
  "thepodium"
];

export const COMMUNICATION_REDIRECTS_CUSTOM_BOTTOM_SPACE = {
  vita: {
    mobile: "16px",
    desktop: "80px",
  },
  houseofsocial: {
    mobile: "16px",
    desktop: "80px",
  },
  studentfm: {
    mobile: "75px",
    desktop: "75px",
  },
  moda: {
    mobile: "100px",
    desktop: "16px",
  },
  aparto: {
    mobile: "100px",
    desktop: "16px",
  },
  hfs: {
    mobile: "40px",
    desktop: "40px",
  },
  almerostudent: {
    desktop: "163px",
    mobile: "40px",
  },
  mansionstudent: {
    desktop: "75px",
    mobile: "75px",
  },
  urbanstudentlife: {
    desktop: "135px",
    mobile: "120px",
  },
  prestigestudentliving: {
    desktop: "135px",
    mobile: "120px",
  },
  essentialstudentliving: {
    desktop: "135px",
    mobile: "120px",
  },
  evostudent: {
    desktop: "135px",
    mobile: "120px",
  },
  universalstudentliving: {
    desktop: "115px",
    mobile: "100px",
  },
};

const hfsSisterBrandsStyles = {
  mobile: "40px",
  desktop: "40px",
  widget_parent_container_bottom_mobile: "0px",
  widget_parent_container_bottom_desktop: "104px",
};

export const WIDGET_BOTTOM_SPACE = {
  moda: {
    mobile: "100px",
    desktop: "16px",
    widget_parent_container_bottom_mobile: "0px",
    widget_parent_container_bottom_desktop: "80px",
  },
  aparto: {
    mobile: "100px",
    desktop: "16px",
    widget_parent_container_bottom_mobile: "0px",
    widget_parent_container_bottom_desktop: "80px",
  },
  hfs: {
    ...hfsSisterBrandsStyles,
  },
  evostudent: {
    ...hfsSisterBrandsStyles,
  },
  urbanstudentlife: {
    ...hfsSisterBrandsStyles,
  },
  essentialstudentliving: {
    ...hfsSisterBrandsStyles,
  },
  prestigestudentliving: {
    ...hfsSisterBrandsStyles,
  },
  almerostudent: {
    desktop: "66px",
    mobile: "16px",
    widget_parent_container_bottom_mobile: "0px",
    widget_parent_container_bottom_desktop: "130px",
  },
};

export const CLIENT_LOGO_OVERRIDE_STYLES = {
  milestone: {
    desktop: {
      height: "47px",
      minWidth: "45px",
      minHeight: "47px",
      borderRadius: "30%",
    },
    mobile: {
      height: "43px",
      minWidth: "40px",
      minHeight: "43px",
      borderRadius: "30%",
    },
  },
};

export const clientsWithPrivacyMessage: string[] = [];

export const languageConfig = {
  languages: {
    popular_languages: [
      {
        language: "en",
        name: "English",
      },
      {
        language: "en-GB",
        name: "English (United Kingdom)",
      },
      {
        language: "en-US",
        name: "English (United States)",
      },
      {
        language: "zh",
        name: "Chinese (Simplified)",
      },
      {
        language: "hi",
        name: "Hindi",
      },
      {
        language: "es",
        name: "Spanish",
      },
      {
        language: "fr",
        name: "French",
      },
      {
        language: "ar",
        name: "Arabic",
      },
    ],
    other_languages: [
      {
        language: "ab",
        name: "Abkhaz",
      },
      {
        language: "ace",
        name: "Acehnese",
      },
      {
        language: "ach",
        name: "Acholi",
      },
      {
        language: "af",
        name: "Afrikaans",
      },
      {
        language: "sq",
        name: "Albanian",
      },
      {
        language: "alz",
        name: "Alur",
      },
      {
        language: "am",
        name: "Amharic",
      },
      {
        language: "hy",
        name: "Armenian",
      },
      {
        language: "as",
        name: "Assamese",
      },
      {
        language: "awa",
        name: "Awadhi",
      },
      {
        language: "ay",
        name: "Aymara",
      },
      {
        language: "az",
        name: "Azerbaijani",
      },
      {
        language: "ban",
        name: "Balinese",
      },
      {
        language: "bm",
        name: "Bambara",
      },
      {
        language: "ba",
        name: "Bashkir",
      },
      {
        language: "eu",
        name: "Basque",
      },
      {
        language: "btx",
        name: "Batak Karo",
      },
      {
        language: "bts",
        name: "Batak Simalungun",
      },
      {
        language: "bbc",
        name: "Batak Toba",
      },
      {
        language: "be",
        name: "Belarusian",
      },
      {
        language: "bem",
        name: "Bemba",
      },
      {
        language: "bn",
        name: "Bengali",
      },
      {
        language: "bew",
        name: "Betawi",
      },
      {
        language: "bho",
        name: "Bhojpuri",
      },
      {
        language: "bik",
        name: "Bikol",
      },
      {
        language: "bs",
        name: "Bosnian",
      },
      {
        language: "br",
        name: "Breton",
      },
      {
        language: "bg",
        name: "Bulgarian",
      },
      {
        language: "bua",
        name: "Buryat",
      },
      {
        language: "yue",
        name: "Cantonese",
      },
      {
        language: "ca",
        name: "Catalan",
      },
      {
        language: "ceb",
        name: "Cebuano",
      },
      {
        language: "ny",
        name: "Chichewa",
      },
      {
        language: "zh-TW",
        name: "Chinese (Traditional)",
      },
      {
        language: "cv",
        name: "Chuvash",
      },
      {
        language: "co",
        name: "Corsican",
      },
      {
        language: "crh",
        name: "Crimean Tatar",
      },
      {
        language: "hr",
        name: "Croatian",
      },
      {
        language: "cs",
        name: "Czech",
      },
      {
        language: "da",
        name: "Danish",
      },
      {
        language: "dv",
        name: "Dhivehi",
      },
      {
        language: "din",
        name: "Dinka",
      },
      {
        language: "doi",
        name: "Dogri",
      },
      {
        language: "dov",
        name: "Dombe",
      },
      {
        language: "nl",
        name: "Dutch",
      },
      {
        language: "dz",
        name: "Dzongkha",
      },
      {
        language: "eo",
        name: "Esperanto",
      },
      {
        language: "et",
        name: "Estonian",
      },
      {
        language: "ee",
        name: "Ewe",
      },
      {
        language: "fj",
        name: "Fijian",
      },
      {
        language: "tl",
        name: "Filipino",
      },
      {
        language: "fi",
        name: "Finnish",
      },
      {
        language: "fy",
        name: "Frisian",
      },
      {
        language: "ff",
        name: "Fulani",
      },
      {
        language: "gaa",
        name: "Ga",
      },
      {
        language: "gl",
        name: "Galician",
      },
      {
        language: "ka",
        name: "Georgian",
      },
      {
        language: "de",
        name: "German",
      },
      {
        language: "el",
        name: "Greek",
      },
      {
        language: "gn",
        name: "Guarani",
      },
      {
        language: "gu",
        name: "Gujarati",
      },
      {
        language: "ht",
        name: "Haitian Creole",
      },
      {
        language: "cnh",
        name: "Hakha Chin",
      },
      {
        language: "ha",
        name: "Hausa",
      },
      {
        language: "haw",
        name: "Hawaiian",
      },
      {
        language: "iw",
        name: "Hebrew",
      },
      {
        language: "hil",
        name: "Hiligaynon",
      },
      {
        language: "hmn",
        name: "Hmong",
      },
      {
        language: "hu",
        name: "Hungarian",
      },
      {
        language: "hrx",
        name: "Hunsrik",
      },
      {
        language: "is",
        name: "Icelandic",
      },
      {
        language: "ig",
        name: "Igbo",
      },
      {
        language: "ilo",
        name: "Ilocano",
      },
      {
        language: "id",
        name: "Indonesian",
      },
      {
        language: "ga",
        name: "Irish",
      },
      {
        language: "it",
        name: "Italian",
      },
      {
        language: "ja",
        name: "Japanese",
      },
      {
        language: "jw",
        name: "Javanese",
      },
      {
        language: "kn",
        name: "Kannada",
      },
      {
        language: "pam",
        name: "Kapampangan",
      },
      {
        language: "kk",
        name: "Kazakh",
      },
      {
        language: "km",
        name: "Khmer",
      },
      {
        language: "cgg",
        name: "Kiga",
      },
      {
        language: "rw",
        name: "Kinyarwanda",
      },
      {
        language: "ktu",
        name: "Kituba",
      },
      {
        language: "gom",
        name: "Konkani",
      },
      {
        language: "ko",
        name: "Korean",
      },
      {
        language: "kri",
        name: "Krio",
      },
      {
        language: "ku",
        name: "Kurdish (Kurmanji)",
      },
      {
        language: "ckb",
        name: "Kurdish (Sorani)",
      },
      {
        language: "ky",
        name: "Kyrgyz",
      },
      {
        language: "lo",
        name: "Lao",
      },
      {
        language: "ltg",
        name: "Latgalian",
      },
      {
        language: "la",
        name: "Latin",
      },
      {
        language: "lv",
        name: "Latvian",
      },
      {
        language: "lij",
        name: "Ligurian",
      },
      {
        language: "li",
        name: "Limburgish",
      },
      {
        language: "ln",
        name: "Lingala",
      },
      {
        language: "lt",
        name: "Lithuanian",
      },
      {
        language: "lmo",
        name: "Lombard",
      },
      {
        language: "lg",
        name: "Luganda",
      },
      {
        language: "luo",
        name: "Luo",
      },
      {
        language: "lb",
        name: "Luxembourgish",
      },
      {
        language: "mk",
        name: "Macedonian",
      },
      {
        language: "mai",
        name: "Maithili",
      },
      {
        language: "mak",
        name: "Makassar",
      },
      {
        language: "mg",
        name: "Malagasy",
      },
      {
        language: "ms",
        name: "Malay",
      },
      {
        language: "ms-Arab",
        name: "Malay (Jawi)",
      },
      {
        language: "ml",
        name: "Malayalam",
      },
      {
        language: "mt",
        name: "Maltese",
      },
      {
        language: "mi",
        name: "Maori",
      },
      {
        language: "mr",
        name: "Marathi",
      },
      {
        language: "chm",
        name: "Meadow Mari",
      },
      {
        language: "mni-Mtei",
        name: "Meiteilon (Manipuri)",
      },
      {
        language: "min",
        name: "Minang",
      },
      {
        language: "lus",
        name: "Mizo",
      },
      {
        language: "mn",
        name: "Mongolian",
      },
      {
        language: "my",
        name: "Myanmar (Burmese)",
      },
      {
        language: "nr",
        name: "Ndebele (South)",
      },
      {
        language: "new",
        name: "Nepalbhasa (Newari)",
      },
      {
        language: "ne",
        name: "Nepali",
      },
      {
        language: "no",
        name: "Norwegian",
      },
      {
        language: "nus",
        name: "Nuer",
      },
      {
        language: "oc",
        name: "Occitan",
      },
      {
        language: "or",
        name: "Odia (Oriya)",
      },
      {
        language: "om",
        name: "Oromo",
      },
      {
        language: "pag",
        name: "Pangasinan",
      },
      {
        language: "pap",
        name: "Papiamento",
      },
      {
        language: "ps",
        name: "Pashto",
      },
      {
        language: "fa",
        name: "Persian",
      },
      {
        language: "pl",
        name: "Polish",
      },
      {
        language: "pt",
        name: "Portuguese (Brazil)",
      },
      {
        language: "pa",
        name: "Punjabi (Gurmukhi)",
      },
      {
        language: "pa-Arab",
        name: "Punjabi (Shahmukhi)",
      },
      {
        language: "qu",
        name: "Quechua",
      },
      {
        language: "rom",
        name: "Romani",
      },
      {
        language: "ro",
        name: "Romanian",
      },
      {
        language: "rn",
        name: "Rundi",
      },
      {
        language: "ru",
        name: "Russian",
      },
      {
        language: "sm",
        name: "Samoan",
      },
      {
        language: "sg",
        name: "Sango",
      },
      {
        language: "sa",
        name: "Sanskrit",
      },
      {
        language: "gd",
        name: "Scots Gaelic",
      },
      {
        language: "nso",
        name: "Sepedi",
      },
      {
        language: "sr",
        name: "Serbian",
      },
      {
        language: "st",
        name: "Sesotho",
      },
      {
        language: "crs",
        name: "Seychellois Creole",
      },
      {
        language: "shn",
        name: "Shan",
      },
      {
        language: "sn",
        name: "Shona",
      },
      {
        language: "scn",
        name: "Sicilian",
      },
      {
        language: "szl",
        name: "Silesian",
      },
      {
        language: "sd",
        name: "Sindhi",
      },
      {
        language: "si",
        name: "Sinhala",
      },
      {
        language: "sk",
        name: "Slovak",
      },
      {
        language: "sl",
        name: "Slovenian",
      },
      {
        language: "so",
        name: "Somali",
      },
      {
        language: "su",
        name: "Sundanese",
      },
      {
        language: "sw",
        name: "Swahili",
      },
      {
        language: "ss",
        name: "Swati",
      },
      {
        language: "sv",
        name: "Swedish",
      },
      {
        language: "tg",
        name: "Tajik",
      },
      {
        language: "ta",
        name: "Tamil",
      },
      {
        language: "tt",
        name: "Tatar",
      },
      {
        language: "te",
        name: "Telugu",
      },
      {
        language: "tet",
        name: "Tetum",
      },
      {
        language: "th",
        name: "Thai",
      },
      {
        language: "ti",
        name: "Tigrinya",
      },
      {
        language: "ts",
        name: "Tsonga",
      },
      {
        language: "tn",
        name: "Tswana",
      },
      {
        language: "tr",
        name: "Turkish",
      },
      {
        language: "tk",
        name: "Turkmen",
      },
      {
        language: "ak",
        name: "Twi",
      },
      {
        language: "uk",
        name: "Ukrainian",
      },
      {
        language: "ur",
        name: "Urdu",
      },
      {
        language: "ug",
        name: "Uyghur",
      },
      {
        language: "uz",
        name: "Uzbek",
      },
      {
        language: "vi",
        name: "Vietnamese",
      },
      {
        language: "cy",
        name: "Welsh",
      },
      {
        language: "xh",
        name: "Xhosa",
      },
      {
        language: "yi",
        name: "Yiddish",
      },
      {
        language: "yo",
        name: "Yoruba",
      },
      {
        language: "yua",
        name: "Yucatec Maya",
      },
      {
        language: "zu",
        name: "Zulu",
      },
      {
        language: "he",
        name: "Hebrew",
      },
      {
        language: "jv",
        name: "Javanese",
      },
      {
        language: "zh-CN",
        name: "Chinese (Simplified)",
      },
    ],
  },
};
